import { render, staticRenderFns } from "./CoursesListAction.vue?vue&type=template&id=19291882&"
import script from "./CoursesListAction.vue?vue&type=script&lang=js&"
export * from "./CoursesListAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports